// extracted by mini-css-extract-plugin
export default {"title":"TermsOfUse_title__mViTY","message":"TermsOfUse_message__4hZLX"};